const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.FacilityBlackoutServiceSimpleClient =
  function FacilityBlackoutServiceSimpleClient(hostname, credentials, options) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.createFacilityBlackout = this.createFacilityBlackout.bind(this);
    this.pullFacilityBlackouts = this.pullFacilityBlackouts.bind(this);
    this.cancelFacilityBlackout = this.cancelFacilityBlackout.bind(this);
    this.excludeSingleFacilityBlackoutDate =
      this.excludeSingleFacilityBlackoutDate.bind(this);
    this.setRepeatToForFacilityBlackout =
      this.setRepeatToForFacilityBlackout.bind(this);
  };
const methodInfo_FacilityBlackoutService_CreateFacilityBlackout =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityBlackoutService/CreateFacilityBlackout",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest,
    imports.stronachgroup.first.racehorse360.FacilityBlackout,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.FacilityBlackout.decode
  );
module.exports.FacilityBlackoutServiceSimpleClient.prototype.createFacilityBlackout =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateFacilityBlackoutRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/CreateFacilityBlackout",
      message,
      metadata || {},
      methodInfo_FacilityBlackoutService_CreateFacilityBlackout
    );
  };
const methodInfo_FacilityBlackoutService_PullFacilityBlackouts =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityBlackoutService/PullFacilityBlackouts",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest,
    imports.stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullFacilityBlackoutsResponse.decode
  );
module.exports.FacilityBlackoutServiceSimpleClient.prototype.pullFacilityBlackouts =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullFacilityBlackoutsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/PullFacilityBlackouts",
      message,
      metadata || {},
      methodInfo_FacilityBlackoutService_PullFacilityBlackouts
    );
  };
const methodInfo_FacilityBlackoutService_CancelFacilityBlackout =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityBlackoutService/CancelFacilityBlackout",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest,
    imports.stronachgroup.first.racehorse360.FacilityBlackout,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.FacilityBlackout.decode
  );
module.exports.FacilityBlackoutServiceSimpleClient.prototype.cancelFacilityBlackout =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CancelFacilityBlackoutRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/CancelFacilityBlackout",
      message,
      metadata || {},
      methodInfo_FacilityBlackoutService_CancelFacilityBlackout
    );
  };
const methodInfo_FacilityBlackoutService_ExcludeSingleFacilityBlackoutDate =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityBlackoutService/ExcludeSingleFacilityBlackoutDate",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest,
    imports.stronachgroup.first.racehorse360.FacilityBlackout,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.FacilityBlackout.decode
  );
module.exports.FacilityBlackoutServiceSimpleClient.prototype.excludeSingleFacilityBlackoutDate =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ExcludeSingleFacilityBlackoutDateRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/ExcludeSingleFacilityBlackoutDate",
      message,
      metadata || {},
      methodInfo_FacilityBlackoutService_ExcludeSingleFacilityBlackoutDate
    );
  };
const methodInfo_FacilityBlackoutService_SetRepeatToForFacilityBlackout =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.FacilityBlackoutService/SetRepeatToForFacilityBlackout",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest,
    imports.stronachgroup.first.racehorse360.FacilityBlackout,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.FacilityBlackout.decode
  );
module.exports.FacilityBlackoutServiceSimpleClient.prototype.setRepeatToForFacilityBlackout =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SetRepeatToForFacilityBlackoutRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.FacilityBlackoutService/SetRepeatToForFacilityBlackout",
      message,
      metadata || {},
      methodInfo_FacilityBlackoutService_SetRepeatToForFacilityBlackout
    );
  };
